/** Client-routed 404 — the SPA's stand-in for Next.js's `not-found.tsx`. */
import Link from "@/compat/link";

export function NotFoundPage() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-6 text-center">
      <p className="cp-micro-label mb-2">404</p>
      <h1 className="mb-2 text-2xl font-bold text-[var(--cp-ink)]">Page not found</h1>
      <p className="mb-6 max-w-md text-sm text-[var(--cp-ink-2)]">
        That address doesn&apos;t match anything in AIM.
      </p>
      <Link
        href="/dashboard"
        className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
      >
        Back to Dashboard
      </Link>
    </div>
  );
}
